export default "__VITE_ASSET__hPIukXvQ__"